<div>
  <landing-page-main-page-header [applicationType]="application.applicationType"></landing-page-main-page-header>
  <div class="content-container ">
    <span>Du har allerede sendt inn byggesøknaden for {{application.address | formatAddress}}, men den er ennå ikke bekreftet levert.</span>
    <span>Søknaden ble sendt {{application.sendDate | date: 'yyyy-MM-dd HH:mm'}}.</span>
    <span>Søknaden med vedlegg blir lagret i ditt arkiv i Altinn, med referanse {{application.arCode}}.</span>
  </div>
</div>
